/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:8ac4fe8e-051f-43e3-a282-9f5b78cc1c02",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_jkGoV1FPd",
    "aws_user_pools_web_client_id": "5l3o2i706dt04hn1bapqf95pgn",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "cocinaconloquetienes-assets",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
